/**
 * @desc 包裹异常确认
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.abnormalConfirmation.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackage/abnormalConfirmation`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
